import { render, staticRenderFns } from "./NavJustified.vue?vue&type=template&id=079643df&"
import script from "./NavJustified.vue?vue&type=script&lang=js&"
export * from "./NavJustified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports